import {makeStyles} from '@material-ui/core'

export default makeStyles(theme => ({
  root: {
    background: theme.palette.type === 'light' ? '#f9f9fa' : '#333',
    '& > *:first-child': {
      marginRight: theme.spacing(2),
    },
  },
}))
